import { Box, IconButton, Stack, SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import React from 'react';
import { DeleteOutline, Edit } from '@mui/icons-material';

const buttonContainer: SxProps = {
  p: 1,
  minWidth: 0
};

const iconButtonsContainer: SxProps = {
  display: 'flex',
  gap: 1
};

type Props = {
  onActionClick: () => void;
  isEditing: boolean;
  isDeletable?: boolean;
  onDelete?: () => void;
  disableEdit?: boolean;
  useIcons?: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  bottomActions?: {
    showSave?: boolean;
    showCancel?: boolean;
    showDelete?: boolean;
    showEdit?: boolean;
    customActions?: React.ReactNode;
  };
};

const EditableTextInputActions: React.FC<Props> = ({
  onActionClick,
  isEditing,
  isDeletable,
  onDelete,
  disableEdit,
  useIcons = false,
  onEdit,
  onSave,
  onCancel,
  bottomActions
}) => {
  const { showSave, showCancel, showDelete, showEdit, customActions } =
    bottomActions || {};

  if (useIcons) {
    return (
      <Box sx={iconButtonsContainer}>
        {!disableEdit && !isEditing && (
          <IconButton size="small" onClick={onActionClick} color="primary">
            <Edit />
          </IconButton>
        )}
        {isDeletable && onDelete && (
          <IconButton size="small" onClick={onDelete} color="error">
            <DeleteOutline />
          </IconButton>
        )}
      </Box>
    );
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {showEdit && onEdit && !isEditing && (
        <Button onClick={onEdit} sx={buttonContainer}>
          Edit
        </Button>
      )}
      {showSave && isEditing && (
        <Button onClick={onSave} sx={buttonContainer}>
          Save
        </Button>
      )}
      {showCancel && onCancel && isEditing && (
        <Button onClick={onCancel} sx={buttonContainer}>
          Cancel
        </Button>
      )}
      {showDelete && onDelete && (
        <Button onClick={onDelete} sx={buttonContainer} state="destructive">
          Delete
        </Button>
      )}
      {customActions}
    </Stack>
  );
};

export { EditableTextInputActions };
